export default __webpack_public_path__ + "static/media/call_history.718d19b1.png";